module.exports = __webpack_public_path__ + "img/ic_checkFailed.a8e36628.png";